import VerifyRequestedCode from '@features/games/profile/validate-phone/verify-code-form/verify-code-form';
export default VerifyRequestedCode;
